import base from "/vercel/path0/images/genius-active.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");